
import { useEffect } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import ProductCard from "../components/ProductCard";
import { useProductStore } from "../stores/useProductStore";

const CategoryPage = () => {
	const { category } = useParams();
	const [searchParams] = useSearchParams();
	const subcategory = searchParams.get('subcategory');
	
	// שימוש ב-store למוצרים
	const { products, loading, fetchProductsByCategory } = useProductStore();
	
	useEffect(() => {
		fetchProductsByCategory(category);
	}, [category, fetchProductsByCategory]);

	console.log("CategoryPage: category =", category);
	console.log("CategoryPage: subcategory =", subcategory);
	console.log("CategoryPage: products =", products);
	console.log("CategoryPage: loading =", loading);
	

	// פילטור מוצרים לפי קטגוריית משנה - פשוט ומקצועי
	const filteredProducts = products && Array.isArray(products) ? products.filter(product => {
		// וולידציה בסיסית
		if (!product || !product.category) return false;
		
		// אם אין קטגוריית משנה, מציג הכל מהקטגוריה הראשית
		if (!subcategory) return true;
		
		// פילטור לפי קטגוריית משנה - שרשראות
		if (category === 'necklaces') {
			switch (subcategory) {
				case 'gemstone':
					return product.stone && product.stone !== 'none' && product.stone !== null;
				case 'luxury':
					return product.price >= 250;
				case 'steel':
					return product.material?.includes('פלדת אל חלד') || 
						   product.description?.includes('פלדת') || 
						   product.name?.includes('פלדת');
				case 'daily':
					return product.price < 250 && 
						   (product.stone === 'none' || !product.stone || product.stone === null);
				default:
					return true;
			}
		}
		
		// פילטור לפי קטגוריית משנה - עגילים
		if (category === 'earrings') {
			switch (subcategory) {
				case 'geometric':
					return product.description?.includes('גאומטרית') || 
						   product.name?.includes('גאומטרית') ||
						   product.description?.includes('סטייל');
				case 'stone':
					return product.stone && product.stone !== 'none' && product.stone !== null;
				case 'gold':
					return product.description?.includes('זהב') || 
						   product.name?.includes('זהב');
				case 'daily':
					return product.price < 120;
				default:
					return true;
			}
		}
		
		// פילטור לפי קטגוריית משנה - צמידים
		if (category === 'bracelets') {
			switch (subcategory) {
				case 'stone':
					return product.stone && product.stone !== 'none' && product.stone !== null;
				case 'steel':
					return product.material?.includes('פלדת אל חלד') || 
						   product.description?.includes('פלדת') || 
						   product.name?.includes('פלדת');
				case 'natural':
					return product.material?.includes('חוט') || 
						   product.description?.includes('בעבודת יד');
				case 'luxury':
					return product.price >= 150;
				default:
					return true;
			}
		}
		
		return true;
	}) : [];

	// הצגת "בקרוב" עבור טבעות
	if (category === 'rings') {
		return (
			<div className='min-h-screen bg-gradient-to-br from-white via-white to-white' dir="rtl">
				<div className='relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16'>
					<div className="text-center">
						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.6 }}
							className="max-w-2xl mx-auto"
						>
							<div className="mb-8">
								<div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full mb-6 shadow-2xl">
									<span className="text-4xl">💍</span>
								</div>
								<h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
									טבעות SHA-SHA
								</h1>
								<div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/30 rounded-full px-6 py-3 mb-6">
									<div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
									<span className="text-orange-400 font-semibold">בקרוב - טרם הגיע המלאי</span>
								</div>
							</div>
							
							<p className="text-xl text-gray-700 mb-8 leading-relaxed">
								אנחנו מכינים עבורכם קולקציית טבעות מרהיבה שתכלול:
							</p>
							
							<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
								<div className="bg-gray-100 rounded-xl p-6 border border-gray-200">
									<div className="text-2xl mb-3">💎</div>
									<h3 className="text-lg font-semibold text-black mb-2">טבעות אירוסין</h3>
									<p className="text-gray-600 text-sm">יהלומים מרהיבים בעיצובים ייחודיים</p>
								</div>
								<div className="bg-gray-100 rounded-xl p-6 border border-gray-200">
									<div className="text-2xl mb-3">💕</div>
									<h3 className="text-lg font-semibold text-black mb-2">טבעות נישואין</h3>
									<p className="text-gray-600 text-sm">סמל לאהבה נצחית ברמת איכות גבוהה</p>
								</div>
								<div className="bg-gray-100 rounded-xl p-6 border border-gray-200">
									<div className="text-2xl mb-3">⭐</div>
									<h3 className="text-lg font-semibold text-black mb-2">טבעות יומיומיות</h3>
									<p className="text-gray-600 text-sm">עיצובים מודרניים לשימוש יומיומי</p>
								</div>
								<div className="bg-gray-100 rounded-xl p-6 border border-gray-200">
									<div className="text-2xl mb-3">👑</div>
									<h3 className="text-lg font-semibold text-black mb-2">טבעות חותם</h3>
									<p className="text-gray-600 text-sm">עיצוב אישי עם חריטה מיוחדת</p>
								</div>
							</div>
							
							<div className="bg-blue-50 rounded-xl p-6 border border-blue-200 mb-8">
								<h3 className="text-xl font-semibold text-black mb-3">💌 הירשמו לעדכונים</h3>
								<p className="text-gray-500 mb-4">
									נשלח לכם הודעה מיד כשהטבעות יגיעו למלאי!
								</p>
								<a 
									href="/contact" 
									className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-black font-semibold py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-105"
								>
									<span>צרו קשר לעדכונים</span>
									<ArrowLeft className="w-4 h-4" />
								</a>
							</div>
							
							<div className="text-center">
								<p className="text-gray-600 text-sm">
									בינתיים, תוכלו לעיין ב
									<a href="/category/necklaces" className="text-yellow-400 hover:text-yellow-300 mx-1 underline">
										שרשראות
									</a>
									ו
									<a href="/category/earrings" className="text-yellow-400 hover:text-yellow-300 mx-1 underline">
										עגילים
									</a>
									<a href="/category/bracelets" className="text-yellow-400 hover:text-yellow-300 mx-1 underline">
										צמידים
									</a>
									שלנו
								</p>
							</div>
						</motion.div>
					</div>
				</div>
			</div>
		);
	}

	// אם אין מוצרים ולא טוען - אפשר להציג הודעה
	if (!loading && (!products || products.length === 0)) {
		return (
			<div className='min-h-screen' dir="rtl">
				<div className='relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16'>
					<div className="text-center">
						<p className="text-gray-600 mb-4">לא נמצאו מוצרים בקטגוריה זו</p>
						<button 
							onClick={() => window.history.back()}
							className="bg-brand-primary text-black px-4 py-2 rounded-lg hover:bg-opacity-80"
						>
							חזרה
						</button>
					</div>
				</div>
			</div>
		);
	}

	// קביעת כותרת לפי קטגוריה וקטגוריית משנה
	const getCategoryTitle = () => {
		if (category === 'necklaces') return 'שרשראות';
		if (category === 'earrings') return 'עגילים';
		if (category === 'bracelets') return 'צמידים';
		if (category === 'rings') return 'טבעות';
		return category.charAt(0).toUpperCase() + category.slice(1);
	};

	const getSubcategoryTitle = () => {
		if (category === 'necklaces') {
			if (subcategory === 'gemstone') return 'שרשראות אבני חן';
			if (subcategory === 'luxury') return 'שרשראות יוקרה';
			if (subcategory === 'steel') return 'שרשראות פלדת אל חלד';
			if (subcategory === 'daily') return 'שרשראות יומיומיות';
		}
		if (category === 'earrings') {
			if (subcategory === 'shell') return 'עגילי קונכייה';
			if (subcategory === 'onyx') return 'עגילים עם אבני אוניקס';
			if (subcategory === 'studs') return 'עגילים צמודים';
			if (subcategory === 'decorative') return 'עגילים דקורטיביים';
		}
		if (category === 'bracelets') {
			if (subcategory === 'handmade') return 'צמידי אבני חן בעבודת יד';
			if (subcategory === 'classic') return 'צמידים קלאסיים';
			if (subcategory === 'luxury') return 'צמידי יוקרה';
			if (subcategory === 'special') return 'צמידי מחיר מיוחד';
		}
		return subcategory;
	};

	return (
		<div className='min-h-screen bg-white' dir="rtl">
			<div className='relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16'>
				<motion.h1
									className='text-center text-4xl sm:text-5xl font-bold text-black mb-8 
				bg-gradient-to-r from-brand-primary to-[#ac609c] p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-xl transition-all duration-300 group'
					initial={{ opacity: 0, y: -20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				>
					{subcategory ? getSubcategoryTitle() : getCategoryTitle()}
				</motion.h1>

				{/* Breadcrumb לקטגוריות משנה */}
				{subcategory && (
					<motion.div
						className="text-center mb-6"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 0.5, delay: 0.3 }}
					>
											<nav className="inline-flex items-center space-x-2 space-x-reverse bg-gray-800 rounded-lg px-4 py-2">
						<Link 
							to={`/category/${category}`} 
							className="text-gray-600 hover:text-brand-primary transition-colors"
						>
							{getCategoryTitle()}
						</Link>
						<span className="text-gray-500">/</span>
						<span className="text-brand-primary">
							{getSubcategoryTitle()}
						</span>
					</nav>
					</motion.div>
				)}

				{loading && (
					<div className="text-center text-gray-700 text-xl">
						טוען מוצרים...
					</div>
				)}

				<motion.div
					className='grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 justify-items-center'
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
				>
					{!loading && filteredProducts?.length === 0 && (
						<div className='text-center col-span-full'>
							{category === 'rings' ? (
								<div className='space-y-4'>
									<h2 className='text-3xl font-semibold text-yellow-400'>
										בקרוב זמין!
									</h2>
									<p className='text-xl text-gray-700'>
										אנחנו עובדים על הוספת קולקציית טבעות מרהיבה
									</p>
									<div className='mt-8'>
										<img 
											src='/placeholder.jpg' 
											alt='בקרוב זמין' 
											className='w-64 h-64 object-cover rounded-lg mx-auto opacity-50'
										/>
									</div>
								</div>
							) : (
								<div className='space-y-4'>
									<h2 className='text-3xl font-semibold text-yellow-400'>
										{subcategory ? 'לא נמצאו מוצרים בקטגוריית משנה זו' : 'לא נמצאו מוצרים בקטגוריה זו'}
									</h2>
									<p className='text-xl text-gray-700'>
										{subcategory 
											? `נסה לחזור לכל ה${getCategoryTitle()} או לבדוק קטגוריית משנה אחרת`
											: 'נסה לבדוק מאוחר יותר או לבחור קטגוריה אחרת'
										}
									</p>
									{subcategory && (
										<Link 
											to={`/category/${category}`}
											className="inline-block bg-brand-primary text-black px-6 py-3 rounded-lg hover:bg-opacity-80 transition-colors mt-4"
										>
											חזור לכל ה{getCategoryTitle()}
										</Link>
									)}
								</div>
							)}
						</div>
					)}

					{!loading && filteredProducts && Array.isArray(filteredProducts) && filteredProducts.map((product) => (
						<ProductCard key={product._id} product={product} />
					))}
				</motion.div>
			</div>
		</div>
	);
};
export default CategoryPage;
